// Household-timezone calendar helpers. Pure: the caller injects `instant`
// (the server is the only time authority — the worker passes `new Date()`,
// the frontend passes `new Date()`, tests pass a fixed Date). Timezone only
// maps an instant → a local calendar day; all stored timestamps stay UTC-Z.
export const DEFAULT_TIMEZONE = "America/Toronto";
/** True iff `tz` is an IANA zone id the runtime's Intl data accepts. */
export function isValidIanaTimeZone(tz) {
    try {
        new Intl.DateTimeFormat("en-CA", { timeZone: tz });
        return true;
    }
    catch {
        return false;
    }
}
/** The local calendar date (YYYY-MM-DD) for `instant` in IANA zone `tzid`. */
export function localDateInZone(tzid, instant) {
    // en-CA yields YYYY-MM-DD directly.
    return new Intl.DateTimeFormat("en-CA", {
        timeZone: tzid,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }).format(instant);
}
/** The ISO Monday of the week containing `localDate` (YYYY-MM-DD). */
export function mondayOf(localDate) {
    // Non-null: caller passes a validated YYYY-MM-DD string (noUncheckedIndexedAccess
    // otherwise types these as `number | undefined`).
    const [y, m, d] = localDate.split("-").map((n) => Number.parseInt(n, 10));
    // Anchor at UTC noon to avoid any DST edge affecting the weekday arithmetic.
    const dt = new Date(Date.UTC(y, m - 1, d, 12, 0, 0));
    const dow = dt.getUTCDay(); // 0=Sun..6=Sat
    const delta = dow === 0 ? -6 : 1 - dow; // shift back to Monday
    dt.setUTCDate(dt.getUTCDate() + delta);
    return dt.toISOString().slice(0, 10);
}
//# sourceMappingURL=dates.js.map